import React from 'react';
import { useToast } from '../../hooks/useToast';
import { IconWarning, IconCheck, IconInfo } from './Icons';

export function ToastRenderer() {
  const { toasts, dismiss } = useToast();
  return (
    <div className="fixed top-5 left-1/2 -translate-x-1/2 z-[9999] flex flex-col items-center gap-2 pointer-events-none">
      {toasts.map(t => (
        <button
          key={t.id}
          onClick={() => dismiss(t.id)}
          className={`pointer-events-auto flex items-center gap-2.5 px-4 py-3 rounded-2xl text-sm font-medium glass shadow-card cursor-pointer transition-opacity hover:opacity-80 ${
            t.type === 'error'   ? 'border-red-800/50 text-red-300' :
            t.type === 'success' ? 'border-emerald-800/50 text-emerald-300' :
                                   'text-stabeon-text'
          }`}
          style={{ animation: 'toast-in 0.35s cubic-bezier(0.34,1.56,0.64,1)' }}
        >
          <span className="flex-shrink-0">
            {t.type === 'error' ? <IconWarning size={16} /> : t.type === 'success' ? <IconCheck size={16} /> : <IconInfo size={16} />}
          </span>
          {t.message}
          <span className="text-stabeon-muted text-xs ml-1">×</span>
        </button>
      ))}
    </div>
  );
}
